import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=36848282&scoped=true&"
import script from "./Live.vue?vue&type=script&lang=js&"
export * from "./Live.vue?vue&type=script&lang=js&"
import style0 from "./Live.vue?vue&type=style&index=0&id=36848282&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36848282",
  null
  
)

export default component.exports